import { create } from "zustand";

interface AuthStore {
  auth: LoginResponse | null;
  setAuth: (auth: LoginResponse) => void;
  clearAuth: () => void;
}

const useAuth = create<AuthStore>((set) => ({
  auth: null,
  setAuth: (auth) => set({ auth }),
  clearAuth: () => set({ auth: null }),
}));

export default useAuth;
